import APIKeysTable from "@/components/api-keys-table";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Link } from "@tanstack/react-router";
import { Key, Plus } from "lucide-react";

export default function APIKeysManagement({ apiKeys }: { apiKeys: any[] }) {

  return (
    <Card className="overflow-hidden bg-white/80 shadow-sm">
      <CardHeader>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0">
          <div>
            <CardTitle>API Keys</CardTitle>
            <CardDescription>
              Manage your API keys
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        {apiKeys.length === 0 ? (
          <div className="text-center py-8">
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-stone-100">
              <Key className="h-6 w-6 text-stone-500" />
            </div>
            <h3 className="text-lg font-medium text-stone-950 mb-2">
              No API keys yet
            </h3>
            <p className="text-stone-600 mb-4">
              Subscribe to a plan to get your API key
            </p>
            <Button asChild>
              <Link to="/dashboard/billing">
                <Plus className="w-4 h-4 mr-2" />
                Choose Plan
              </Link>
            </Button>
          </div>
        ) : (
          <APIKeysTable apiKeys={apiKeys} />
        )}
      </CardContent>
    </Card>
  );
}
